import { Candidate, CandidateDetail, SupplyType } from 'types/candidate'
import { RegionType } from 'types/region-type'

import { useInfiniteQueryApi, useQueryApi } from 'utils/api'
import { baseAPIPathGuruKS } from 'configs/api'

const basePath = `${baseAPIPathGuruKS}/v1/ps`

interface ParamsGetPSDemandsPengawas {
  id: string
  type: string
}

export interface ResponseSuccessGetPSDemandsPengawas {
  totalPengawasSekolah: number
  totalSchoolDemand: number
}

export const useAPIGetPsDemandsPengawas = (
  params: ParamsGetPSDemandsPengawas
) =>
  useQueryApi<ResponseSuccessGetPSDemandsPengawas>(
    `${basePath}/demands/pengawas`,
    {
      axiosConfig: {
        params,
      },
    }
  )

export interface ParamsGetOverviewSupplies {
  id: string
  type: RegionType
}

export interface ResponseSuccessGetPSOverviewSupplies {
  lastUpdatedAt: string
  totalPreferred: number
  totalBackup: number
}

export const useAPIGetPSOverviewSupplies = (
  params: ParamsGetOverviewSupplies
) =>
  useQueryApi<ResponseSuccessGetPSOverviewSupplies>(
    `${basePath}/overview/supplies`,
    {
      axiosConfig: {
        params,
      },
    }
  )

export interface ParamsGetPSSupplies {
  id: string
  type: RegionType
  page?: number
  pageSize?: number
  supplyType?: SupplyType
}

export interface ResponseSuccessGetPSSupplies {
  data: Candidate[]
  meta: {
    page: number
    pageSize: number
  }
}

export const useAPIGetPSSupplies = (params: ParamsGetPSSupplies) =>
  useInfiniteQueryApi<ResponseSuccessGetPSSupplies>(`${basePath}/supplies`, {
    axiosConfig: {
      params,
    },
    queryConfig: {
      getNextPageParam: ({ data, meta: { page, pageSize } }) => {
        if (!data.length || data.length < params.pageSize) return

        return {
          page: page + 1,
          pageSize,
        }
      },
    },
  })

export const useAPIGetCandidateDetail = (candidateId: string) =>
  useQueryApi<CandidateDetail>(`${basePath}/supplies/${candidateId}`, {
    axiosConfig: {
      method: 'GET',
    },
  })
